import script from "./commentPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./commentPublish.vue?vue&type=script&setup=true&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=423d6066&scoped=true&lang=css"
import "./commentPublish.vue?vue&type=style&index=1&id=423d6066&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423d6066"]])

export default __exports__